export enum API_ENDPOINT {
  USER = "/v1/users",
  USER_V2 = "/v2/users",
  PUBLIC_USER = "v1/public/users",
  ROOM = "v1/rooms",
  ROOM_V2 = "v2/rooms",
  MESSAGE_V1 = "v1/messages",
  MESSAGE_V2 = "v2/messages",
  PARTICIPANT = "v1/participants",
  PARTICIPANT_V2 = "v2/participants",
  RELATIONSHIP = "v1/relationships",
  ADS_CAMPAIGNS = "/ads_campaigns",
  NICKNAME = "/v1/nicknames",
  PUBLIC = "/v1/public",
  DEVICES = "/v1/devices",
  SEARCH = "/v1/search",
  V1 = "/v1",
  CONFIRM_EVENTS = "/v1/events/confirm",
  AUDIENCE_SUBSCRIPTION_V1 = "/v1/subscription-plans",
}
